export const API_v4_URL = "https://mars.ninjaos.com/apiV4/";
export const MEDIA_SERVER_URL = "https://mars.ninjaos.com/";


// WEBPACK FOOTER //
// ./src/constants/index.js